import { render, staticRenderFns } from "./InstagramAnalyticsPublicSummary.vue?vue&type=template&id=f4674a04"
import script from "./InstagramAnalyticsPublicSummary.vue?vue&type=script&lang=ts"
export * from "./InstagramAnalyticsPublicSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports